var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShortTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_17245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2648 10.4658C26.0863 10.4577 25.9139 10.5247 25.7846 10.6467C25.6574 10.7686 25.5835 10.9373 25.5835 11.1141C25.5814 13.4673 25.5814 21.3724 25.5814 23.7419C25.5814 24.1138 25.8872 24.4186 26.2648 24.4186C28.6249 24.4186 36.4172 24.4186 38.8286 24.4186C39.0215 24.4186 39.2041 24.3414 39.3375 24.2032C39.4709 24.0671 39.5407 23.8821 39.5345 23.6932C39.1836 15.8592 33.2116 10.7788 26.2648 10.4658Z",
    fill: "#FF9E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1187 12.2294C30.9719 5.08255 19.5345 5.01351 12.5721 11.9759C5.60969 18.9383 5.67873 30.3758 12.8255 37.5226C18.7496 43.4466 27.6356 44.5106 34.4622 40.7264C35.3567 40.2305 36.4838 40.5537 36.9797 41.4482C37.4755 42.3427 37.1524 43.4698 36.2579 43.9657C27.9899 48.5489 17.3022 47.237 10.2066 40.1415C1.65806 31.5929 1.50015 17.81 9.95318 9.357C18.4062 0.903977 32.1891 1.06189 40.7377 9.61046C47.8667 16.7395 49.1574 27.495 44.4963 35.779C43.9948 36.6703 42.8657 36.9863 41.9743 36.4848C41.083 35.9833 40.767 34.8541 41.2685 33.9628C45.1166 27.1236 44.0709 18.1816 38.1187 12.2294Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_17245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShortTime);
export default __webpack_public_path__ + "static/media/ic_short_time.9f9d62bfe881379016fc45d1baef4825.svg";
export { ForwardRef as ReactComponent };